import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const DEFAULT_VERSION = 'video_complex_v1';
const AVAILABLE_VERSIONS = [
  { id: 'video_complex_v1', label: 'Video → IA (prompt complexe)' },
  { id: 'video_benchmark_v1', label: 'Video → IA Bench (prompt simple)' },
  { id: 'images_to_ia_v1', label: 'Images → IA (YOLO + Vision)' },
  { id: 'cars2025_yolo_v1', label: 'YOLO 2025 (Cars2025)' },
];

const STORAGE_KEY = 'louca_config';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [selectedVersion, setSelectedVersion] = useState(DEFAULT_VERSION);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed.version) {
          setSelectedVersion(parsed.version);
        }
      }
    } catch (error) {
      console.error('Failed to load persisted config', error);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: selectedVersion }));
    } catch (error) {
      console.error('Failed to persist config', error);
    }
  }, [selectedVersion]);

  const value = useMemo(
    () => ({
      selectedVersion,
      setSelectedVersion,
      availableVersions: AVAILABLE_VERSIONS
    }),
    [selectedVersion]
  );

  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return context;
};

